// TODO:Cleanup after experiment is finished MOVE-26228
import { DRP_PAGE_ID, DRP_SUBMIT_ROUTE } from '../../stores/page';

export const routes = {
  [DRP_SUBMIT_ROUTE]: {
    path: `/${DRP_PAGE_ID}/:listingId/submit/:anonymousDealApplicationId/`,
  },
};
